import gql from 'graphql-tag';

import { cardCategoryDetails } from '../fragments/cardCategoryDetails';

export const cardCategoryCreate = gql`
  mutation cardCategoryCreate($input: CardCategoryCreateInput!) {
    cardCategoryCreate(input: $input) {
      card_category {
        ...cardCategoryDetails
      }
    }
  }
  ${cardCategoryDetails}
`;

export const cardCategoryUpdate = gql`
  mutation cardCategoryUpdate($input: CardCategoryUpdateInput!) {
    cardCategoryUpdate(input: $input) {
      card_category {
        ...cardCategoryDetails
      }
    }
  }
  ${cardCategoryDetails}
`;

export const cardCategoryDelete = gql`
  mutation cardCategoryDelete($input: CardCategoryDeleteInput!) {
    cardCategoryDelete(input: $input) {
      success
    }
  }
`;
